import { lazy } from "react";

const edit = lazy(() => import("./Edit").then(m => ({ default: m.PortalFirmEdit })));
const list = lazy(() => import("./List").then(m => ({ default: m.PortalFirmList })));

export default { edit, list };
